import axios from 'axios';

// 輔助函式：用來從 document.cookie 中讀取 CSRF token
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

/**
 * 建立並回傳一個已配置好通用攔截器的 Axios 實例
 * @param {object} config - 傳遞給 axios.create 的配置物件 (e.g., baseURL)
 * @returns {import('axios').AxiosInstance}
 */
export function createApiCSRFClient(config) {
  // 1. 根據傳入的設定建立實例
  const apiClient = axios.create(config);
  // 2. 應用所有通用的攔截器
  // 應用 CSRF 攔截器
  apiClient.interceptors.request.use(
    (config) => {
      const unsafeMethods = ['post', 'put', 'patch', 'delete'];
      if (unsafeMethods.includes(config.method)) {
        config.headers['X-CSRFToken'] = getCookie('csrftoken');
      }
      return config;
    },
    (error) => {
      console.error('getCookie Error:', error.response?.data || error.message);
      return Promise.reject(error);
    }
  );
  // 應用其他攔截器，例如統一錯誤處理
  apiClient.interceptors.response.use(
    (response) => response, // 成功的回應直接回傳
    (error) => {
      // 在這裡可以做統一的錯誤處理，例如彈出提示訊息
      console.error('API Error:', error.response?.data || error.message);
      return Promise.reject(error);
    }
  );
  // 3. 回傳配置好的實例
  return apiClient;
}